// ----------------------------------------------------------------------

const shape = {
  borderRadius: 3,
  borderRadiusSm: 8,
  borderRadiusMd: 16,
};

export default shape;
